import { Container } from '@material-ui/core';
import Page from '../../components/Page';

export default function ConfigNotifications() {
  return (
    <Page title="Dashboard: Api's | ZIMTA">
      <Container>
        <div> Config Notifications's Page</div>
      </Container>
    </Page>
  );
}
